import { createContext, useContext, type ReactNode } from 'react';

const ChatConversationContext = createContext<string | undefined>(undefined);

export function ChatConversationProvider({
  conversationId,
  children,
}: {
  conversationId: string;
  children: ReactNode;
}) {
  return (
    <ChatConversationContext.Provider value={conversationId}>
      {children}
    </ChatConversationContext.Provider>
  );
}

export function useChatConversationId(): string | undefined {
  return useContext(ChatConversationContext);
}
